import React from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import SMS from '.';
import SMSEdit from './SMSEdit';
import HelpButton from '../../../components/HelpButton';
import BackButton from '../../../components/buttons/BackButton';

const SMSCampaignEditPage = ({
  location,
  match: {
    params: { id },
  },
}) => (
  <SMS>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <div className="row mb-2">
          <div className="col text-left">
            <BackButton />
          </div>
          <div className="col text-right">
            <HelpButton fileName="sms-campaign-edit" />
          </div>
        </div>
        <SMSEdit location={location} campaign id={+id} />
      </React.Suspense>
    </ErrorBoundary>
  </SMS>
);
export default SMSCampaignEditPage;
